<template>
    <div>
        <base-title title="Type In Out" subtitle="List Data Type In Out" />
        <v-data-table :headers="headers" :items="datatable" :search="search" item-key="id" sort-by="id" class="elevation-1"
            :loading="datatableLoading" loading-text="Please wait...">
            <template v-slot:[`item.is_active`]="{ item }">
                <v-chip x-small :color="getColor(item.is_active)" dark>
                    {{ item.is_active ? "Active" : "Not Active" }}
                </v-chip></template>
            <template v-slot:no-data> No data </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="text-center">
                    <v-col cols="12"> <strong>ID:</strong>{{ item.id }} </v-col>
                </td>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon color="warning" class="mr-2" @click.stop="editItem(item)">
                    mdi-pencil-box-outline
                </v-icon>
            </template>

            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" outlined dense
                        hide-details></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialogForm" max-width="450px" persistent>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" small elevation="1" color="primary" class="ma-2 white--text"
                                @click="loader = 'loading3'">
                                Create
                                <v-icon right dark>mdi-plus-circle </v-icon>
                            </v-btn>
                        </template>
                        <v-form ref="form_data" v-model="form_valid" lazy-validation>
                            <v-card class="rounded-lg">
                                <v-card-title class="mb-3">
                                    <span class="headline">{{ form_title }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-text-field v-model="form_data.name" label="Name" outlined dense :rules="rule_name">
                                    </v-text-field>
                                    <v-select v-model="form_data.flag" :items="flag" label="Flag" outlined dense
                                        :rules="rule_flag">
                                    </v-select>
                                    <base-column :lg="4" :md="4" :sm="12" v-if="(ROLE == 'Owner')">
                                        <v-select label="Branch" :items="branch" v-model="form_data.branch_id" dense
                                            item-text="name" item-value="id" outlined></v-select>
                                    </base-column>
                                    <v-textarea v-model="form_data.description" label="Description" outlined dense rows="3">
                                    </v-textarea>
                                    <v-switch dense v-model="form_data.is_active" label="USE">
                                    </v-switch>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn small color="error darken-1" @click.stop="closedialogForm">Cancel
                                        <v-icon right dark>mdi-close </v-icon>
                                    </v-btn>
                                    <v-btn small color="primary" class="ma-2 white--text" @click.stop="save"
                                        :loading="btnLoading" :disabled="!form_valid || btnLoading">
                                        Save
                                        <v-icon right dark>mdi-content-save </v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-dialog>
                </v-toolbar>
            </template>
        </v-data-table>
    </div>
</template>
  
<script>
import { mapGetters } from "vuex";
import { datatableMixin } from "@/mixins/datatable.js";
import BaseTitle from "@/components/base/BaseTitle.vue";

export default {
    components: { BaseTitle },
    name: "TypeInOutIndex",
    mixins: [datatableMixin],
    data: () => ({
        headers: [
            { text: "Name", value: "name" },
            { text: "Flag", value: "flag" },
            { text: "Description", value: "description" },
            { text: "Status", value: "is_active" },
            { text: "Action", value: "actions", sortable: false, width: 100 },
        ],
        branch: [],
        flag: [
            { text: "In", value: "IN" },
            { text: "Out", value: "OUT" },
        ],

        form_data: {
            name: "",
            flag: "",
            branch_id: "",
            description: "",
            is_active: true,
        },
        form_default: {
            name: "",
            flag: "",
            branch_id: "",
            description: "",
            is_active: true,
        },
    }),

    created() {
        this.initialize();
        this.getBranch();
    },

    methods: {
        initialize: async function () {
            this.datatableLoading = true;
            await this.$axios
                .get("/master/type-in-outs", {
                    headers: {
                        Authorization: this.$store.getters["auth/Token"],
                    },
                })
                .then(({ data }) => {
                    this.datatable = data.type_in_outs.data;
                    this.datatableLoading = false;
                })
                .catch(() => {
                    this.datatableLoading = false;
                });
        },

        save: async function () {
            if (this.$refs.form_data.validate()) {
                this.btnLoading = true;
                if (this.editedIndex > -1) {
                    await this.$axios
                        .post(
                            "/master/type-in-outs/" + this.form_data.id,
                            {
                                _method: "PUT",
                                name: this.form_data.name,
                                flag: this.form_data.flag,
                                branch_id: this.form_data.branch_id,
                                description: this.form_data.description,
                                is_active: this.form_data.is_active,
                            },
                            {
                                headers: {
                                    Authorization: this.$store.getters["auth/Token"],
                                },
                            }
                        )
                        .then(({ data }) => {
                            Object.assign(this.datatable[this.editedIndex], data.type_in_outs);
                            this.closedialogForm();
                            this.btnLoading = false;
                        })
                        .catch(() => {
                            this.btnLoading = false;
                        });
                } else {
                    await this.$axios
                        .post(
                            "/master/type-in-outs",
                            {
                                name: this.form_data.name,
                                flag: this.form_data.flag,
                                branch_id: this.form_data.branch_id,
                                description: this.form_data.description,
                                is_active: this.form_data.is_active,
                            },
                            {
                                headers: {
                                    Authorization: this.$store.getters["auth/Token"],
                                },
                            }
                        )
                        .then(({ data }) => {
                            this.datatable.push(data.type_in_outs);
                            this.closedialogForm();
                            this.btnLoading = false;
                        })
                        .catch(() => {
                            this.btnLoading = false;
                        });
                }
            }
        },

        async getBranch() {
            await this.$axios("/master/branches?active=1", {
                headers: {
                    Authorization: this.$store.getters["auth/Token"],
                },
            }).then(({ data }) => {
                this.branch = data.branch.data;
            });
        },
    },
    computed: {
        form_title() {
            return this.editedIndex === -1 ? "Create Type In Out" : "Edit Type In Out";
        },

        ...mapGetters("auth", {
            ROLE: "Role",
        }),
    },
};
</script>